<highcharts-chart
  [Highcharts]="hc"
  [options]="gaugeChart"
  style="width: 100%; height: 100%; display: block"
>
</highcharts-chart>
